import React, { useEffect, useState } from "react";
import { PhoneMultiFactorGenerator, PhoneAuthProvider, RecaptchaVerifier, User, multiFactor, MultiFactorInfo } from "firebase/auth";
import { auth } from "../../../../firebase/firebase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import "./step2.css";
import Button from "../../../../components/Button";
import { ToastContainer } from "react-toastify";

const Step2 = () => {
  const [verification, setverification] = useState("");
  const [captchaVerifier, setCaptchaVerifier] = useState<RecaptchaVerifier | null>(null);
  const navigate = useNavigate();
  const [isFormValid, setIsFormValid] = useState(false);
  const [maskedPhone, setMaskedPhone] = useState("");

  const location = useLocation();

  useEffect(() => {
    const { maskedPhone } = location.state;
    setMaskedPhone(maskedPhone);
  }, [location]);

  React.useEffect(() => {
    if (captchaVerifier === null) {
      const verfifer = JSON.parse(JSON.stringify(window.localStorage.getItem("approvedsignin")));
      if (verfifer === "true") {
        sendOtp();
      } else {
        navigate("/home");
      }
    }
  }, []);

  useEffect(() => {
    const updateMultifactor = async (user: User) => {
      if (user) {
        const mfaUsr = await multiFactor(user);
        if (mfaUsr.enrolledFactors) {
          // Get the user's multi-factor info
          const factors = mfaUsr.enrolledFactors as MultiFactorInfo[];
          const phoneFactor = factors.find(factor => factor.factorId === "phone"); // Find the phone factor

          if (phoneFactor && "phoneNumber" in phoneFactor) {
            // Mask the phone number, showing only the last 4 digits

            const phoneNumber = phoneFactor.phoneNumber as string;
            const masked = phoneNumber.replace(/.(?=.{3})/g, "*");
            setMaskedPhone(masked);
          }
        }
      }
    };
    const user = auth?.currentUser;
    user && updateMultifactor(user);
  }, []);

  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({
    otp: "",
  });

  const [otp, setOtp] = useState("");

  const schema = Yup.object().shape({
    otp: Yup.string().required("Verification code required"),
  });

  useEffect(() => {
    const validate = async (data: { [key: string]: string | undefined }) => {
      try {
        await schema.validate(data, { abortEarly: true });
        setErrors({});
        setIsFormValid(true);
      } catch (err) {
        const validationErrors: { [key: string]: string } = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(err => {
            if (err.path) {
              validationErrors[err.path] = err.message;
            }
          });
        }
        setErrors(validationErrors);
        setIsFormValid(false);
      }
    };
    validate({ otp });
  }, [otp]);

  const sendOtp = async () => {
    try {
      const recaptchaVerifier = new RecaptchaVerifier(auth, "2fa-captcha", {
        size: "invisible",
      });
      recaptchaVerifier.render();
      setCaptchaVerifier(recaptchaVerifier);
      const phoneOpts = {
        multiFactorHint: window.resolver.hints[0],
        session: window.resolver.session,
      };

      const phoneAuthProvider = new PhoneAuthProvider(auth);

      await phoneAuthProvider.verifyPhoneNumber(phoneOpts, recaptchaVerifier).then(verificationId => {
        setverification(verificationId);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const verifyOtp = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    try {
      const cred = PhoneAuthProvider.credential(verification, otp);
      const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);

      const credential = await window.resolver.resolveSignIn(multiFactorAssertion);

      if (credential) {
        window.localStorage.removeItem("approvedsignin");
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Failed to verify the code: ", error);
      alert("The verification code entered is incorrect. Please try again.");
      setErrors({ otp: "Verification code is not valid!" });
    }
  };

  const onBlurMe = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    try {
      await schema.validateAt(name, { [name]: value });

      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  return (
    <>
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Enter verification code sent to your phone number.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Log In</div>
                </div>
                <div className="flex justify-center w-full px-[30px] mb-[30px]">
                  <div className=" bg-skseparatorgray w-full rounded-full h-[5px]">
                    <div className=" bg-skgreen h-[5px] rounded-full" style={{ width: "75%" }}></div>
                  </div>
                </div>
                <div className="mb-5 px-[30px] flex flex-col space-y-[10px] w-full">
                  <label htmlFor="otp" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Verification Code
                  </label>
                  <div className="overflow-hidden formverificationcodefield">
                    <input
                      onBlur={onBlurMe}
                      className="verificationcodetext"
                      type="text"
                      name="otp"
                      value={otp}
                      onChange={e => setOtp(e.target.value)}
                      placeholder="Enter OTP"
                    />
                  </div>

                  {errors.otp && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.otp}</span>}
                  <span className="block mb-2 text-sm text-gray-400 dark:text-gray-600">
                    Verification code sent to the phone ending with {maskedPhone}.
                  </span>
                </div>
                <div className="thickseparator"></div>

                <div className="flex flex-col items-center justify-between w-full p-[30px] md:flex-row-reverse  gap-y-[30px]">
                  <Button to="/" onClick={verifyOtp} className="w-full md:w-auto md:min-w-[120px] formprimarybutton" isDisabled={!isFormValid}>
                    Continue
                  </Button>
                  <Link to="/" className="w-full md:w-auto md:min-w-[120px] formsecondarybutton">
                    Cancel
                  </Link>
                </div>
                <div id="2fa-captcha" style={{ display: "flex", justifyContent: "center" }}></div>
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step2;
